const OrderStatusSkeleton = () => <div className="border-supportiveDarkGray mx-auto animate-pulse px-4 py-6 md:max-w-[628px] md:border" data-sentry-component="OrderStatusSkeleton" data-sentry-source-file="OrderStatusSkeleton.jsx">
    {/* Status Icon */}
    <div className="flex justify-center">
      <div className="size-16 rounded-full bg-gray-300"></div>
    </div>

    {/* Status Message */}
    <div className="mx-auto mt-4 h-6 w-3/4 rounded bg-gray-300"></div>

    {/* Shipping Details */}
    <div className="border-supportiveDarkGray mt-6 space-y-2 border p-4">
      <div className="h-4 w-1/3 rounded bg-gray-300"></div>
      <div className="h-4 w-2/3 rounded bg-gray-300"></div>
      <div className="h-4 w-1/2 rounded bg-gray-300"></div>
      <div className="h-4 w-1/4 rounded bg-gray-300"></div>
    </div>

    {/* Order Summary */}
    <div className="border-supportiveDarkGray mt-4 border bg-white">
      <div className="h-10 w-full rounded bg-gray-300"></div>
      <div className="space-y-4 p-4">
        {Array(2).fill("").map((_, index) => <div key={index} className="flex items-center space-x-4">
              <div className="size-16 rounded bg-gray-300"></div>
              <div className="w-3/4 space-y-2">
                <div className="h-4 w-full rounded bg-gray-300"></div>
                <div className="h-4 w-2/3 rounded bg-gray-300"></div>
              </div>
              <div className="h-4 w-8 rounded bg-gray-300"></div>
            </div>)}
      </div>
    </div>

    {/* Pricing Details */}
    <div className="border-supportiveDarkGray bg-supportiveThinGray mt-4 border p-4">
      <div className="h-4 w-1/2 rounded bg-gray-300"></div>
      <div className="mt-2 h-6 w-full rounded bg-gray-300"></div>
    </div>

    {/* Action Buttons */}
    <div className="mt-6">
      <div className="h-12 w-full rounded bg-gray-300"></div>
    </div>
  </div>;
export default OrderStatusSkeleton;